import Carousel from './Carousel';

function CarouselGateway() {
  return <Carousel />;
}

export default CarouselGateway;
